<script setup lang="ts">
import FieldSelect from './FieldSelect.vue';
import type ValuesSelectField from '@/models/ValuesSelectField';
import { lensModelCollection } from '@/stores/lensModelCollection';
import type LensModel from '@/models/LensModel';
import {computed, ref, watch} from "vue";


const props = defineProps({
    value: {
        type: Number,
        required: false
    },
    modelValue: {
        type: Number,
        required: false
    },
    toricOnly: {
        type: Boolean,
        required: false,
        default: false
    },
})
const emits = defineEmits(['change:idLens'])

const idLen = ref<number|undefined>(props.modelValue)

// No modo tórica só faz sentido escolher uma lente de verdade (precisa do
// idLen pra achar os degraus tóricos cadastrados) — "Custom" não tem isso.
const options = computed<ValuesSelectField[]>(() => {
    const lenses = lensModelCollection
        .filter((lens: LensModel) => !props.toricOnly || lens.toric)
        .sort((lensA: LensModel, lensB: LensModel) => lensA.name > lensB.name ? 1 : -1)
        .map((lens): ValuesSelectField => ({
            'id': lens.id,
            'title': lens.name,
            'value': lens.number.toString(),
        }))

    if (props.toricOnly) {
        return lenses
    }

    return [
        { 'id': 0, 'title': 'Custom', 'value': 'no-lens' },
        ...lenses
    ]
})

watch(props, (newValue) => {
  if(newValue.modelValue != undefined) {
    idLen.value = newValue.modelValue
  }
})

watch(idLen, (newValue: any) => {
    emits ('change:idLens', newValue)
})

</script>

<template>
    <FieldSelect 
        :values="options" 
        :modelValue="idLen"
        @update:modelValue="newValue => idLen = newValue"
    />
</template>